export default __webpack_public_path__ + "src/assets/send.cfdf664a2f946cedca7c574a2a2bd9b0.svg";